import { useState } from 'react';
import { DetailsPanel, EditIcon, FormatInformation, IconButton } from '@weareopenr/component-library';

import VenueDetailsEditModal from 'src/components/VenueDetailsEditModal';
import { IVenue } from 'src/types/venue.types';

export interface IVenueDetails {
  venue: IVenue;
}

const VenueDetails = ({ venue }: IVenueDetails) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  const handleModalClick = () => setIsModalOpen((prev: boolean) => !prev);

  return (
    <>
      <DetailsPanel
        title="Details"
        action={<IconButton buttonStyle="ghost" onClick={handleModalClick} icon={EditIcon} aria-label="Edit details" />}
      >
        <DetailsPanel.Row>
          <DetailsPanel.Column>
            <FormatInformation heading="ID">{venue.venueId}</FormatInformation>
            <FormatInformation heading="Name">{venue.name}</FormatInformation>
            {venue.code && <FormatInformation heading="Code">{venue.code}</FormatInformation>}
            <FormatInformation heading="Trial venue">{venue.isTrial ? 'Yes' : 'No'}</FormatInformation>
          </DetailsPanel.Column>
        </DetailsPanel.Row>
      </DetailsPanel>
      <VenueDetailsEditModal isModalOpen={isModalOpen} onModalClose={handleModalClick} venue={venue} />
    </>
  );
};

export default VenueDetails;
